import styles from '../../styles/animationFades.module.css'; // eslint-disable-line import/order

export const fadeIn = styles.animFadeIn;
export const fadeOut = styles.animFadeOut;
